// extracted by mini-css-extract-plugin
export default {"errorBlock":"errorBlock__hS6DTQbe","contentBlock":"contentBlock__Jo1jVVGE"};